import { render } from "./LaboratorioCreate.vue?vue&type=template&id=eac81b6c&scoped=true"
import script from "./LaboratorioCreate.vue?vue&type=script&lang=js"
export * from "./LaboratorioCreate.vue?vue&type=script&lang=js"

import "./LaboratorioCreate.vue?vue&type=style&index=0&id=eac81b6c&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eac81b6c"]])

export default __exports__